module.exports = __webpack_public_path__ + "static/media/8.101a5fe6.jpg";